import { useCallback, useState } from "react"
import { TCategoriaFinanceiro } from "../../../../../types/api/financeiro/categorias-financeiro"
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao"

export default function Categorias() {

    const [_, setOpenModal] = useState<TOpenModalCategoriaFinanceiro>(null)

    //funções manipuladoras
    const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: TCategoriaFinanceiro | null) => {
        if (action === "close") setOpenModal(null)
        if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
        if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })
    }, [])
    //

    return (
        <>
            <SessaoConfiguracao<TCategoriaFinanceiro>
                titulo="Categorias"
                endpoints={{
                    listar: "financeiro/configuracoes/pesquisar-categorias",
                    deletar: "nenhuma-rota-definida",
                }}
                colunas={colunas}
                queryKey="pesquisar-categorias"
                onEditar={(categoria) => {
                    handleModalAction("open", categoria.id, categoria)
                }}
                possuiAdicionar={false}
                mensagemSucessoDeletar="Categoria deletada com sucesso!"
                mensagemErroDeletar="Erro ao deletar categoria!"
                mensagemSemDados="Nenhuma categoria encontrada."
                podeEditar={() => false}
                podeDeletar={() => false}
            />

        </>
    )
}

const colunas: ConfiguracaoColunas<TCategoriaFinanceiro>[] = [
    {
        campo: "id",
        titulo: "Código",
    },
    {
        campo: "nome",
        titulo: "Nome",
    },
];

export type TOpenModalCategoriaFinanceiro = {
    open: number | boolean | null;
    defaultValue: TCategoriaFinanceiro | null;
} | null
